<template>
  <div>
    <material-card :color="titleColor" class="super-height"
                   :title="$t('my_schedule_view.title')"
                   :text="$t('my_schedule_view.subtitle_timeline')">
      <ProgressBar :loading="timelineData.length == 0" color="deep-purple accent-4" />
      <v-layout row>
        <v-flex xs12>
          <slot name="actions"></slot>
        </v-flex>
      </v-layout>
      <v-card>
        <v-timeline>
          <v-layout row>
            <v-flex xs12>
              <v-timeline-item v-for="(item, index) in timelineData"
                               :key="item.itemDate"
                               :color="getColor(item.IndexBojeTimelinea, item)">
                <!--color="red lighten-2">-->
                <template v-slot:opposite>
                  <span>{{item.Datum | moment('DD.MM.YYYY')}}</span>
                </template>
                <v-card class="elevation-2" v-if="index % 2 != 0">
                  <v-card-text class="headline pb-0 text-center1">{{item.Ime}}  </v-card-text>
                  <v-card-text class="body-2 py-1 text-center">{{item.TerminOd | moment("HH:mm")}} - {{item.TerminDo | moment("HH:mm")}}</v-card-text>
                  <v-card-text class="body-2 py-0">{{item.Naziv}}</v-card-text>
                  <v-card-text class="py-0">
                    {{$t('my_schedule_view.classroom')}}: {{item.UcionicaNaziv}}
                  </v-card-text>
                  <v-card-text class="py-1">
                    {{item.UcionicaUlica}}, {{item.UcionicaGrad}}
                  </v-card-text>
                </v-card>

                <v-card class="elevation-2 text-right" v-if="index % 2 == 0">
                  <v-card-text class="headline pb-0 text-center1">{{item.Ime}}  </v-card-text>
                  <v-card-text class="body-2 py-1 text-center">{{item.TerminOd | moment("HH:mm")}} - {{item.TerminDo | moment("HH:mm")}}</v-card-text>
                  <v-card-text class="body-2 py-0">{{item.Naziv}}</v-card-text>
                  <v-card-text class="py-0">
                    {{$t('my_schedule_view.classroom')}}: {{item.UcionicaNaziv}}
                  </v-card-text>
                  <v-card-text class="py-1">
                    {{item.UcionicaUlica}}, {{item.UcionicaGrad}}
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-flex>

          </v-layout>
        </v-timeline>
      </v-card>
    </material-card>
  </div>
  <!--</material-card>-->

</template>


<script>

  export default {
    name: 'MyScheduleTimeline',
    props: {
      titleColor: '',
      timelineView: false,
      timelineData: { type: Array, default: [] },
    },
    methods: {
      getColor(index, item) {
        if ((index + 1) > this.colorOptions.length) {
          return this.colorOptions[0].value;
        }
        else {
          return this.colorOptions[index].value;
        }
      }
    },
    data() {
      return {
        colorOptions: [
          { text: 'Light Blue', value: 'light-blue' },
          { text: 'Amber', value: 'amber' },
          { text: 'Red', value: 'red' },
          { text: 'Pink', value: 'pink' },
          { text: 'Purple', value: 'purple' },
          { text: 'Deep Purple', value: 'deep-purple' },
          { text: 'Indigo', value: 'indigo' },
          { text: 'Blue', value: 'blue' },
          { text: 'Cyan', value: 'cyan' },
          { text: 'Teal', value: 'teal' },
          { text: 'Yellow', value: 'yellow' },
          { text: 'Accent', value: 'accent' },
          { text: 'Green', value: 'green' },
          { text: 'Light Green', value: 'light-green' },
          { text: 'Lime', value: 'lime' },
          { text: 'Orange', value: 'orange' },
          { text: 'Deep Orange', value: 'deep-orange' },
          { text: 'Brown', value: 'brown' },
          { text: 'Blue Gray', value: 'blue-gray' },
          { text: 'Gray', value: 'gray' },
        ]
      }
    }
  }
</script>


<style>
  /* Crta se u material-card sakrije iza i pomakne gore, pa to sredim */
  /*.theme--light.v-timeline:before {
    z-index: 1;
    margin-top: 200px;
  }

  .theme--light.v-timeline .v-timeline-item__dot {
    z-index: 2;
  }*/
  .super-height {
    height: 2000px;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Education/schedule_components/MyScheduleTimeline.vue